module.exports = __webpack_public_path__ + "media/images/vector-13@2x-b8746e07462b8b783572534c3155707a.png";